import AOS from "aos";

// Content stays visible if animation setup or JavaScript fails.
AOS.init({ disable: window.matchMedia("(prefers-reduced-motion: reduce)").matches });
document.documentElement.classList.add("aos-ready");

const boidSettings = {
  speed: 3.5,
  turnStrength: 0.2,
  separation: 1.5,
  alignment: 1.0,
  cohesion: 1.0,
};
const easterEggState = {
  wildUntil: 0,
};
const boidControlMaps = {
  speed: { min: 1, max: 7, decimals: 1 },
  separation: { min: 0, max: 3, decimals: 1 },
  alignment: { min: 0, max: 3, decimals: 1 },
  cohesion: { min: 0, max: 3, decimals: 1 },
};

const mapNormalizedControl = (setting, normalizedValue) => {
  const config = boidControlMaps[setting];
  if (!config) return normalizedValue;
  const ratio = normalizedValue / 100;
  return config.min + (config.max - config.min) * ratio;
};

const formatControlValue = (setting, actualValue) => {
  const config = boidControlMaps[setting];
  if (!config) return String(actualValue);
  return actualValue.toFixed(config.decimals);
};

// navigation.js
document.addEventListener("DOMContentLoaded", function () {
  const toggler = document.getElementById("nav-toggler");
  const nav = document.querySelector(".nav");
  const collapsibles = document.querySelectorAll(".collapsible");
  const collapsibleContent = document.querySelector(".collapsible__content");
  const navLinks = document.querySelectorAll(".nav__item > a");
  const readingLog = document.querySelector(".reading-log");
  const boidsControls = document.querySelectorAll("[data-boids-control]");
  const heroSection = document.getElementById("heroSection");
  const heroTitle = document.querySelector("#heroSection .block__heading");
  const heroTagline = document.querySelector("#heroSection .hero__tagline");
  const crowTrigger = document.getElementById("crow");
  const defaultTagline = heroTagline?.textContent || "";
  let typedBuffer = "";

  const releaseGoebelSecret = () => {
    heroTitle.classList.remove("hero-title--secret");
    heroTitle.classList.add("hero-title--secret-exit");
    document.body.classList.remove("goebel-mode");

    if (heroTagline) {
      heroTagline.textContent = defaultTagline;
      heroTagline.classList.remove("hero-tagline--secret");
      heroTagline.classList.add("hero-tagline--secret-exit");

      window.setTimeout(() => {
        heroTagline.classList.remove("hero-tagline--secret-exit");
      }, 700);
    }

    window.setTimeout(() => {
      heroTitle.classList.remove("hero-title--secret-exit");
    }, 700);
  };

  const revealCrowSecret = () => {
    if (!crowTrigger) return;
    crowTrigger.classList.remove("crow-secret--active");
    void crowTrigger.offsetWidth;
    crowTrigger.classList.add("crow-secret--active");

    window.clearTimeout(crowTrigger.crowSecretTimeoutId);
    crowTrigger.crowSecretTimeoutId = window.setTimeout(() => {
      crowTrigger.classList.remove("crow-secret--active");
    }, 1500);
  };

  const activateGoebelSecret = () => {
    if (!heroTitle || !heroSection) return;

    easterEggState.wildUntil = Date.now() + 5200;

    heroTitle.classList.remove("hero-title--secret");
    void heroTitle.offsetWidth;

    heroTitle.classList.add("hero-title--secret");

    if (heroTagline) {
      heroTagline.textContent = "GOEBEL MODE | ENGAGED";
      heroTagline.classList.remove("hero-tagline--secret");
      void heroTagline.offsetWidth;
      heroTagline.classList.add("hero-tagline--secret");
    }

    document.body.classList.remove("goebel-mode");
    void document.body.offsetWidth;
    document.body.classList.add("goebel-mode");

    revealCrowSecret();

    window.clearTimeout(heroTitle.secretTimeoutId);
    heroTitle.secretTimeoutId = window.setTimeout(() => {
      releaseGoebelSecret();
    }, 5200);
  };

  toggler.addEventListener("click", function () {
    nav.classList.toggle("collapsible--expanded");
    const isExpanded = nav.classList.contains("collapsible--expanded");
    toggler.setAttribute("aria-expanded", isExpanded);
    if (isExpanded) {
      collapsibleContent.style.maxHeight =
        collapsibleContent.scrollHeight + "px";
    } else {
      collapsibleContent.style.maxHeight = null;
    }
  });
  toggler.addEventListener("keypress", function (e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggler.click();
    }
  });
  navLinks.forEach((link) => {
    link.addEventListener("click", function () {
      if (window.innerWidth <= 767) {
        nav.classList.remove("collapsible--expanded");
        toggler.setAttribute("aria-expanded", "false");
        collapsibleContent.style.maxHeight = null;
      }
    });
  });
  const handleResponsiveNav = () => {
    if (window.innerWidth > 767) {
      // Larger screens
      nav.classList.remove("collapsible--expanded");
      toggler.setAttribute("aria-expanded", "false");
      collapsibleContent.style.maxHeight = null;
    } else {
      // Mobile screens
      nav.classList.remove("collapsible--expanded");
      toggler.setAttribute("aria-expanded", "false");
      collapsibleContent.style.maxHeight = null;
    }
  };
  handleResponsiveNav();
  window.addEventListener("resize", handleResponsiveNav);

  if (readingLog) {
    const months = Array.from(readingLog.querySelectorAll(".reading-month"));
    months
      .sort((a, b) => {
        const aDate = a.querySelector("time")?.getAttribute("datetime") || "";
        const bDate = b.querySelector("time")?.getAttribute("datetime") || "";
        return bDate.localeCompare(aDate);
      })
      .forEach((month) => {
        readingLog.appendChild(month);
      });
  }

  boidsControls.forEach((control) => {
    const setting = control.dataset.boidsControl;
    const valueLabel = document.querySelector(`[data-boids-value="${setting}"]`);

    const syncValue = () => {
      const normalizedValue = Number(control.value);
      const actualValue = mapNormalizedControl(setting, normalizedValue);
      boidSettings[setting] = actualValue;
      if (valueLabel) valueLabel.textContent = String(normalizedValue);
    };

    syncValue();
    control.addEventListener("input", syncValue);
  });

  if (crowTrigger) {
    crowTrigger.addEventListener("click", revealCrowSecret);
    crowTrigger.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        revealCrowSecret();
      }
    });
  }

  document.addEventListener("keydown", (event) => {
    const target = event.target;
    if (
      target instanceof HTMLElement &&
      (target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.tagName === "SELECT" ||
        target.isContentEditable)
    ) {
      return;
    }

    if (event.key.length === 1 && !event.metaKey && !event.ctrlKey && !event.altKey) {
      typedBuffer = (typedBuffer + event.key.toLowerCase()).slice(-12);
      if (typedBuffer.includes("goebel") && heroTitle) {
        activateGoebelSecret();
        typedBuffer = "";
      }
    }
  });
});

//logo gradient based on mouse movement from Hyperplexed
const logos = document.querySelectorAll(".jg__logo"); // all elements with .jg__logo
document.addEventListener("mousemove", (e) => {
  const mouseX = e.clientX / window.innerWidth;
  const mouseY = e.clientY / window.innerHeight;
  const gradientStart = `hsla(180, 13%, 58%, 1)`;
  const gradientEnd = `hsla(335, 16%, 61%, 1)`;
  const gradientPosition = `${mouseX * 100}% ${mouseY * 100}%`;
  logos.forEach((logo) => {
    logo.style.background = `linear-gradient(90deg, ${gradientStart}, ${gradientEnd})`;
    logo.style.backgroundSize = "200%";
    logo.style.backgroundPosition = gradientPosition;
    logo.style.webkitBackgroundClip = "text";
    logo.style.webkitTextFillColor = "transparent";
  });
});

// hacker effect from hyperplexed
const letters = "BEGHJLNO";
document.querySelectorAll(".skill__title").forEach((element) => {
  element.onmouseover = (event) => {
    const originalText = element.dataset.value;
    let iteration = 0;
    clearInterval(element.hackerInterval);
    element.hackerInterval = setInterval(() => {
      event.target.innerText = originalText
        .split("")
        .map((letter, index) => {
          if (index < iteration) {
            return originalText[index];
          }
          return letters[Math.floor(Math.random() * 26)];
        })
        .join("");
      if (iteration >= originalText.length) {
        clearInterval(element.hackerInterval);
      }
      iteration += 1 / 3;
    }, 30);
  };
});

// Load the decorative canvas only after the page has had a chance to paint.
if (document.getElementById("heroSection")) {
  const loadBoids = () => {
    import("./boids.js")
      .then(({ startBoids }) => startBoids(boidSettings, easterEggState))
      .catch((error) => console.error("Unable to start the flock animation:", error));
  };
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(loadBoids, { timeout: 1500 });
      } else {
        window.setTimeout(loadBoids, 0);
      }
    });
  });
}

//essays
document.querySelectorAll(".blog__post").forEach((post) => {
  const key = post.id;
  const contentDiv = post.querySelector(".essay-content");
  if (!contentDiv || contentDiv.hasAttribute("data-essay-key")) return;

  if (window.essays && window.essays[key]) {
    contentDiv.innerHTML = window.essays[key]
      .split("\n\n")
      .map((paragraph) => `<p>${paragraph.trim()}</p>`)
      .join("");
  } else {
    contentDiv.innerHTML = "<p>Essay not found.</p>";
  }
});

// books/books.js
document
  .querySelectorAll(".essay-content[data-essay-key]")
  .forEach((contentDiv) => {
    const key = contentDiv.dataset.essayKey;

    if (window.essays && window.essays[key]) {
      contentDiv.innerHTML = window.essays[key]
        .split("\n\n")
        .map((paragraph) => `<p>${paragraph.trim()}</p>`)
        .join("");
    } else {
      contentDiv.innerHTML = "<p>Review not found.</p>";
    }
  });

// Gallery dependencies are only requested by gallery.html.
if (document.querySelector(".gallery")) {
  import("./gallery.js")
    .then(({ initGallery }) => initGallery())
    .catch((error) => console.error("Unable to initialize the gallery:", error));
}
